import { FormApi } from 'final-form'
import { get, zipObject } from 'lodash'
import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'

import FormComponent from '../../Form'
import { ReduxAction } from '../Redux/actions'
import {
  IField,
  IFilter,
  IFilterInfinity,
  IUi,
  TFApplyLocalFilter,
  TFilterForm,
  TSaveUi,
  TSetFilter,
  TSetFilterMode,
} from '../types'
import Form from './Form'

interface IFilterNewProps extends IFilterInfinity, TFilterForm {
  filters: IFilter[]
  filterMode?: string
  clearFilters?: () => void
  setDetailFilterOpen: (val: IUi) => void
  initFilters?: IField[]
  initialFilter?: IField
  detailFilterOpen: boolean
  setFilterMode?: ReduxAction
}

interface FilterNewProps extends IFilterNewProps {
  setIncluded?: boolean
  initialValues: any
  applyColor: string
  isMobile: boolean
  saveUi?: TSaveUi
}

const Filter = (props: FilterNewProps): React.ReactElement => {
  const {
    filters,
    setFilter,
    applyFilter,
    setFilterMode,
    filterMode = '',
    setIncluded = false,
    initialValues,
    clearFilters,
    applyColor = 'primary',
    isMobile,
    setDetailFilterOpen,
    useLocalStateFiltering = false,
    applyLocalFilter,
    saveUi,
    initFilters,
    detailFilterOpen,
  } = props

  const [form, setForm] = useState<FormApi>()

  const submit = (): void => {
    // console.log("submit")
  }

  const apply = (reset: boolean): void => {
    if (useLocalStateFiltering) {
      if (applyLocalFilter) {
        applyLocalFilter({ reset: reset })
      }
    } else {
      if (applyFilter && saveUi) {
        applyFilter && applyFilter({ reset: { reset: reset } })
        saveUi && saveUi({ isDetailOpen: false })
      }
    }
  }

  return (
    <div className="mx-2" id="infinity-table__filter-sidebar">
      <Row>
        <Col>
          <h3>{i18n.t(`advanced_filter`, `Erweiterter Filter`)}</h3>
        </Col>
      </Row>

      <div className="panel-body">
        <FormComponent
          onSubmit={submit}
          subscription={{ submitting: true, pristine: true }}
          initialValues={{
            ...initialValues,
            ...zipObject(
              get(props.filterForm, 'filter', []).map((f: IField) => f.field),
              get(props.filterForm, 'filter', []).map((f: IField) => f.value),
            ),
          }}
        >
          <Form
            form={form}
            initialFilters={props.initialFilter as IFilter}
            getFormApi={setForm}
            filters={filters}
            setFilter={setFilter as TSetFilter}
            apply={apply}
            setFilterMode={setFilterMode as TSetFilterMode}
            filterMode={filterMode}
            setIncluded={setIncluded}
            applyColor={applyColor}
            isMobile={isMobile}
            setDetailFilterOpen={setDetailFilterOpen}
            useLocalStateFiltering={useLocalStateFiltering}
            applyLocalFilter={applyLocalFilter as TFApplyLocalFilter}
            saveUi={saveUi as TSaveUi}
            // handleFilterModeClick={handleFilterModeClick}
          />
        </FormComponent>
      </div>
    </div>
  )
}

export default Filter
